import React from 'react';
import CommonHeader from './components/CommonHeader';

const Home = () => {
  return (
    <>
      <CommonHeader />
      <main className="py-6 bg-surface-secondary" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="container-fluid text-center">
          <h2>Welcome to the Travel Agency Portal</h2>
          <p style={{ color: '#888', marginTop: '1rem' }}>
            Please use the navigation menu to access your permitted pages.<br/>
            If you believe you should have access to more features, contact your administrator.
          </p>
        </div>
      </main>
    </>
  );
};

export default Home; 